export const EMPTY_VALUE = ' (empty value) ';

export enum ReleasedTypeText {
    UNDEFINED = 'Nicht Freigegeben',
    NOT_RELEASED = 'In Prüfung',
    RELEASED = 'Abgeschlossen',
}

export interface CorrectedTotalSummary {
    id: number;
    offeredClusterId: number;
    worktypeId: number;
    worktypeName: string;
    worktypeForecaster?: string;
    channelId: number;
    channelName: string;
    taskId?: number;
    taskName?: string;
    worktypeLocationId: number;
    locationId: number;
    location: string;
    released?: boolean;
    sum?: number;
}
